<template>
  <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10">
    <!-- Header Section -->
    <div class="d-flex align-center py-5 mb-6 animate-fade-in-up stagger-1" style="border-bottom: 1px solid rgba(255, 255, 255, 0.08)">
      <v-btn class="premium-btn-icon-circle mr-4" icon @click="$router.push('/shop')">
        <v-icon color="white">mdi-chevron-left</v-icon>
      </v-btn>
      <h1 class="premium-title-gradient text-h5 font-weight-black mb-0">Personalisierung</h1>
    </div>

    <v-form @submit.prevent ref="shopCheckoutForm" class="ma-auto animate-fade-in-up stagger-2" style="max-width: 800px" lazy-validation novalidate>
      <div v-for="(product, index) in mappedCartProducts" :key="product.title + index" class="glass-card pa-6 mb-6 d-block" dark>
        <!-- Product Preview Row -->
        <v-row no-gutters class="align-center mb-6">
          <v-col cols="8" class="pr-4">
            <h2 class="text-h6 font-weight-bold white--text mb-1">{{ product.title }}</h2>
            <p class="grey--text text--lighten-1 text-subtitle-2 mb-0" style="line-height: 1.4">{{ product.shortDescription }}</p>
          </v-col>
          <v-col cols="4" class="d-flex justify-end">
            <v-img :aspect-ratio="1.6" class="rounded-xl elevation-3" max-width="150" :src="'/img/' + product.picture"></v-img>
          </v-col>
        </v-row>

        <v-divider style="background-color: rgba(255, 255, 255, 0.08)" class="mb-5"></v-divider>

        <!-- Personalisation Fields -->
        <h3 class="text-subtitle-1 font-weight-bold white--text mb-4">Für wen ist dieses Produkt?</h3>

        <v-row>
          <v-col cols="12" sm="6" class="py-1">
            <v-text-field
              label="Vorname"
              filled
              rounded
              dark
              :rules="rules.required"
              class="premium-input"
              v-model="productPersonalisations[index].prename"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="py-1">
            <v-text-field
              label="Nachname"
              filled
              rounded
              dark
              :rules="rules.required"
              class="premium-input"
              v-model="productPersonalisations[index].lastname"></v-text-field>
          </v-col>
          <v-col cols="12" class="py-1">
            <v-textarea
              filled
              rounded
              dark
              label="Text auf dem Gutschein"
              :rules="rules.required"
              counter="550"
              class="premium-input"
              rows="4"
              v-model="productPersonalisations[index].text"></v-textarea>
          </v-col>
        </v-row>

        <v-divider style="background-color: rgba(255, 255, 255, 0.08)" class="my-4"></v-divider>

        <!-- Item Footer Actions -->
        <v-row no-gutters class="align-center justify-space-between pt-2">
          <v-col cols="7" class="d-flex justify-start">
            <v-btn @click="createTestPrintversion(product, index)" class="premium-btn-outline px-5 py-4" small>
              Beispiel Ausdruck
              <v-icon right size="16">mdi-eye-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" class="d-flex justify-end">
            <span style="color: #00b074; font-weight: 900; font-size: 1.5rem"> CHF {{ product.price }}.- </span>
          </v-col>
        </v-row>
      </div>
    </v-form>

    <!-- Dynamic checkout total and CTA button -->
    <div class="d-flex flex-column align-center justify-center my-10 animate-fade-in-up stagger-3">
      <p class="grey--text text--lighten-2 text-subtitle-1 mb-2">Gesamtsumme der Bestellung</p>
      <div class="white--text text-h4 font-weight-black mb-5" style="color: #00b074 !important">{{ cartTotalPrice }} CHF</div>

      <v-btn class="premium-btn py-7 px-12 text-h6 font-weight-bold" x-large @click="buyProducts()">
        <v-icon left>mdi-credit-card-check-outline</v-icon>
        Jetzt sicher kaufen
      </v-btn>
    </div>

    <v-dialog style="overflow: hidden" @click:outside="paymentInitiated = false" v-model="paymentInitiated" persistent>
      <payment-dialog
        @completed="adyenPaymentCompleted"
        :amount="paymentAmount"
        :resortID="paymentResortID"
        :studio="paymentStudio"
        :purchaseID="purchaseID"
        :profileID="profileID"
        v-if="paymentInitiated"></payment-dialog>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api"
import { mapGetters, mapActions, mapState } from "vuex"
import PaymentDialog from "../payment/paymentDialog.vue"

export default {
  beforeDestroy() {
    //window.removeEventListener('beforeunload', this.preventPageReload)
  },
  components: {
    PaymentDialog,
  },
  data() {
    return {
      productPersonalisations: [],
      paymentInitiated: false,
      purchaseID: null,
      profileID: null,
      paymentAmount: null,
      paymentStudio: "5f326a24ae8863640c859e75",
      paymentResortID: "1",
      drawer: false,
      products: [],
      rules: {
        required: [(v) => !!v || "Dieses Feld ist erforderlich"],
        maxLength750: [(v) => v.length <= 550 || "Nicht mehr als 550 Zeichen"],
      },
    }
  },
  async created() {
    //window.addEventListener('beforeunload', this.preventPageReload)

    if (!this.cartProducts.length) this.$router.push("/shop")
    let amount = this.cartProducts.reduce((a, b) => a + b.amount, 0)
    for (let i = 0; i < amount; i++) {
      this.productPersonalisations.push({ prename: "", lastname: "", text: "" })
    }
  },
  computed: {
    ...mapState("shopStore", ["cartVisibilityToggle", "cartProducts"]),
    ...mapGetters("shopStore", ["cartTotalPrice"]),
    mappedCartProducts() {
      let mappedProducts = []
      this.cartProducts.forEach((product) => {
        for (let i = 0; i < product.amount; i++) {
          mappedProducts.push(product)
        }
      })
      return mappedProducts
    },
  },
  methods: {
    ...mapActions("shopStore", ["addProductToCart", "removeProductFromCart", "openProductFromStore"]),
    /*    preventPageReload(event) {
                // Check if the dialog is open, and if so, prevent the page reload
    
                event.preventDefault()
                event.returnValue = ''
            },*/
    async createTestPrintversion(product, index) {
      if (this.productPersonalisations[index].prename && this.productPersonalisations[index].lastname && this.productPersonalisations[index].text) {
        await api.productExamplePrintVersion({ ...product, ...this.productPersonalisations[index] })
      } else {
        this.$toast.error("Fülle alle Felder aus")
      }
    },
    async buyProducts() {
      if (!this.$refs.shopCheckoutForm.validate()) {
        this.$toast.error("Fülle alle Felder aus.")
        return
      }
      let preparedProducts = this.cartProducts.map((product, index) => {
        return {
          ...product,
          personalization: this.productPersonalisations[index],
        }
      })
      let createdPayment = await api.createProductPayment(preparedProducts)
      this.paymentAmount = createdPayment.amount
      this.purchaseID = createdPayment._id

      this.paymentInitiated = true
    },
    openProduct(id) {
      this.openProductFromStore(id)
    },
  },
  watch: {
    cartVisibilityToggle() {
      this.drawer = true
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.premium-title-gradient {
  background: linear-gradient(135deg, #ffffff 40%, #a3e635 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-family);
  font-weight: 800 !important;
  letter-spacing: -0.03em;
  text-transform: none !important;
}

::v-deep .premium-btn-icon-circle {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 50% !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-icon-circle:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.08) translateY(-1px) !important;
}

::v-deep .glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01) !important;
}

::v-deep .premium-btn {
  background: var(--brand-gradient) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  letter-spacing: 0.02em !important;
  border-radius: 20px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 176, 116, 0.4), var(--shadow-glow) !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  border: none !important;
  text-transform: none !important;
}

::v-deep .premium-btn:hover {
  background: var(--brand-gradient-hover) !important;
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 15px 30px -5px rgba(0, 176, 116, 0.55), 0 0 30px rgba(0, 176, 116, 0.3) !important;
}

::v-deep .premium-btn:active {
  transform: translateY(-1px) !important;
}

::v-deep .premium-btn-outline {
  background: transparent !important;
  color: var(--brand-primary) !important;
  font-weight: 700 !important;
  border: 1.5px solid rgba(0, 176, 116, 0.4) !important;
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  text-transform: none !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-outline:hover {
  background: rgba(0, 176, 116, 0.06) !important;
  border-color: var(--brand-primary) !important;
  color: var(--brand-primary) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 0 20px rgba(0, 176, 116, 0.1) !important;
}

::v-deep .premium-input .v-input__slot {
  background: rgba(255, 255, 255, 0.02) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: none !important;
}

::v-deep .premium-input.v-input--is-focused .v-input__slot {
  border-color: var(--brand-primary) !important;
  background: rgba(255, 255, 255, 0.04) !important;
  box-shadow: 0 0 25px rgba(0, 176, 116, 0.15) !important;
}

::v-deep .premium-input label {
  color: var(--text-secondary) !important;
  font-size: 0.9rem !important;
}

::v-deep .premium-input input, 
::v-deep .premium-input textarea {
  color: #ffffff !important;
  font-size: 1rem !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }
.stagger-3 { animation-delay: 0.3s; }

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
